{
  "loading": "Läser in...",
  "placeholder": "Välj…"
}
